import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';

import {GetAllAdgroupPayloadModel, CreateAdgroupPayloadModel, UpdateAdgroupPayloadModel} from './adgroup_interfaces';
import {Observable, of} from 'rxjs';


@Injectable({providedIn: 'root'})
export class AdgroupService{

  url:string = `${environment['API_URL']}`

  constructor(private http: HttpClient,) {} //end constructor


  gets(endpoint: string, is_mocked: boolean = false): Observable<GetAllAdgroupPayloadModel[]> {

    if (is_mocked) {
      return of<GetAllAdgroupPayloadModel[]>(
          [
            {
              "adgroup_id": "1",
              "name": "Mock Client",
              "status": "active",
              "type": "email"
            }
        ]
      )
    } // end if is_mocked

    let url: string = `${this.url}/${endpoint}`;
    return this.http.get<GetAllAdgroupPayloadModel[]>(url);
  } // end gets

  get(endpoint: string, is_mocked: boolean = false): Observable<GetAllAdgroupPayloadModel> {

    if(is_mocked) {
      return of<GetAllAdgroupPayloadModel>(

        {
          "adgroup_id": "1",
          "name": "Mock Client",
          "status": "active",
          "type": "email"
        }

      )
    } //end if is_mocked

    let url: string = `${this.url}/${endpoint}`;
    return this.http.get<GetAllAdgroupPayloadModel>(url);
  } //end gets

  post(endpoint: string, data: CreateAdgroupPayloadModel){
    return this.http.post<any>(`${this.url}/${endpoint}`, data,{observe: 'response'});
  } //end post

  put(endpoint: string, data: UpdateAdgroupPayloadModel){
    return this.http.put<any>(`${this.url}/${endpoint}`, data,{observe: 'response'});
  } //end put

  delete(endpoint: string): Observable<any> {
    const url = `${this.url}/${endpoint}`;
    return this.http.delete<any>(url);
  } //end getAlerts





} //end AdgroupService
